import React from 'react';
import { brand } from '../../config/brand';
import { useReveal } from '../../hooks/useReveal';
import SplitText from '../SplitText';
import './TechStack.css';

const TechStack: React.FC = () => {
  const ref = useReveal();
  const groups = Object.entries(brand.techStack) as [string, string[]][];

  return (
    <section className="stack section" id="stack" aria-labelledby="stack-heading" ref={ref}>
      <div className="container">
        <span className="section-label">Our Stack</span>
        <h2 className="section-title reveal" id="stack-heading">
          <SplitText text="Battle-tested tools, not experiments" highlight="not experiments" />
        </h2>
        <p className="section-subtitle reveal reveal-delay-1">
          We pick the right tool for the job — proven libraries and frameworks that perform in
          production.
        </p>

        {/* One hairline table instead of two infinite marquees: denser, and it
            removes two always-running CSS animations from every page view. */}
        <div className="stack__table reveal reveal-delay-2">
          {groups.map(([category, techs]) => (
            <div className="stack__row" key={category}>
              <span className="stack__category">{category}</span>
              <div className="stack__items">
                {techs.map((tech) => (
                  <span className="stack__badge" key={tech}>{tech}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
